// Only an authenticated embedded plans screen installs this handler.
// Ordinary web app refreshes continue through VersionCheckService unchanged.
let refreshEmbeddedScreen: (() => void) | undefined;

export function registerMcpEmbedRefresh(handler: () => void): void {
  refreshEmbeddedScreen = handler;
}

// A raw reload would replay a consumed one-use handoff. Embedded plans ask the
// host for a fresh screen instead; return false preserves normal web refresh.
export function requestMcpEmbedRefresh(): boolean {
  if (!refreshEmbeddedScreen) return false;
  refreshEmbeddedScreen();
  return true;
}
